"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
exports.implementation = /*#__PURE__*/function () {
  function NavigatorIDImpl() {
    _classCallCheck(this, NavigatorIDImpl);
  }
  _createClass(NavigatorIDImpl, [{
    key: "appCodeName",
    get: function get() {
      return "Mozilla";
    }
  }, {
    key: "appName",
    get: function get() {
      return "Netscape";
    }
  }, {
    key: "appVersion",
    get: function get() {
      return "4.0";
    }
  }, {
    key: "platform",
    get: function get() {
      return "";
    }
  }, {
    key: "product",
    get: function get() {
      return "Gecko";
    }
  }, {
    key: "productSub",
    get: function get() {
      return "20030107";
    }

    // see Navigator constructor for userAgent
  }, {
    key: "vendor",
    get: function get() {
      return "Apple Computer, Inc.";
    }
  }, {
    key: "vendorSub",
    get: function get() {
      return "";
    }
  }]);
  return NavigatorIDImpl;
}();